module.exports = __webpack_public_path__ + "static/media/woman-map.889105e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/woman-map.jpg
// module id = 210
// module chunks = 0